import React from 'react';
import {ContractProjectHeader} from "../../containers/ContractProjectHeader/ContractProjectHeader";
import {Container} from "../../components/Container/Container";
import SideBar from "../../containers/SideBar/SideBar.jsx";


export const ContractProjectLayout = ({children}) => {
    return <>
        <ContractProjectHeader/>
        <SideBar/>
        <Container>
            {children}
        </Container>
    </>
}